import moment from 'moment'
import { pick } from 'lodash'

import { showAsCurrency } from '../'

// Function below takes data object and matches it to render template object
// Values in the data object will be formatted according to their corresponding field types
export const applyRenderTemplate = (data, renderTemplate) => {
  if (renderTemplate) {
    let d = pick(data, Object.keys(renderTemplate))  // pick creates an object composed of the picked object properties

    Object.keys(d).forEach(key => {
      if (typeof d[key] === 'object') {
        d[key] = applyRenderTemplate(d[key], renderTemplate[key])
      } else {
        switch (renderTemplate[key]) {
          case 'CurrencyField':
            d[key] = showAsCurrency('R', d[key], 2, true)
            break

          case 'DateField':
            d[key] = moment(d[key]).format('DD/MM/YYYY')
            break

          case 'DateTimeField':
            d[key] = moment(d[key]).format('DD/MM/YYYY HH:mm')
            break

          // NOTE: add checks against any other field types that might require render functions

          default:
            break
        }
      }
    })

    return d
  } else {
    return null
  }
}

export const formatMetricValueByFieldType = (value, fieldType) => {
  switch (fieldType) {
    case 'CurrencyField':
      return showAsCurrency('R', value, 2, true)

    case 'DateField':
      return moment(value).format('DD/MM/YYYY')

    case 'DateTimeField':
      return moment(value).format('DD/MM/YYYY HH:mm')

    // NOTE: add more case as becomes necessary

    default:
      return value
  }
}



// WEBPACK FOOTER //
// ./src/utils/metrics/index.js